export default "/storefront/client/images/browser_out_of_date.png";